import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';
export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade: Legal ',
    metaTitle: 'Lemonade: Legal ',
    description:
      'Find all of Lemonade’s important legal documents, disclosures, and consumer notices to stay informed about our services and compliance policies.',
  },
  MDXContent: content as DocumentTypes,
};
